export default __webpack_public_path__ + "static/media/logo.eb35e369.jpeg";